import React, { useEffect, useState } from 'react'
import Resumes from "../resumetemplates/Resumes";
// import { connect } from 'react-redux';
import PreviewIcon from '../../assets/images-new/icons/visibility.svg';
import { BREADCRUMB_LINKS, FINAL_RESUME, REARRANGE_LINK } from '../../constants/constants';
import { useResume } from '../../context/ResumeContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { removeBodyScroll } from '../../helper';
import { useResumePreviewSize } from '../common/useResumePreviewSize';
import IconGrid from '../../assets/images-new/icons/window-grid.svg';

const RightSection = (props) => {
    const [width, height, scale] = useResumePreviewSize();
    const { 
        resume,
        showPreview, 
        setShowPreview 
    } = useResume();

    // //const [fullscreen, setFullScreen] = useState(false);
    const [tooltip, showToolTip] = useState(false);
    const [tttxt, setTttxt] = useState('');
    const history = useHistory();
    const changeTooltip = () => {
        Object.keys(BREADCRUMB_LINKS).map(function (key, index) {
            if (document.location.pathname == BREADCRUMB_LINKS[key].link) {
                setTttxt(BREADCRUMB_LINKS[key].tooltip)
                showToolTip(true)
            }
        })
    }
    const closeOverLay = (e) => {
        if (e.target.className == 'right right__fullscreen') {
            setShowPreview(!showPreview);
            removeBodyScroll(false);
        }
        e.stopPropagation();
    }

    // const getScale = (w, h) => {
    //     return w / 640;
    // };
    // const updateResumeSize = () => {
    //     const resumeDiv = document.getElementById('preview-resume');
    //     if (resumeDiv) {
    //         const scalingAreas = resumeDiv.querySelectorAll('.scaling-area');
    //         scalingAreas.forEach(scalingArea => {
    //             const scale = getScale(resumeDiv.clientWidth, resumeDiv.clientHeight);
    //             scalingArea.style.transform = `scale(${scale})`;
    //         });
    //     }
    // };

    // useEffect(() => {
    //     const timeoutId = setTimeout(() => {
    //     updateResumeSize();
    //     }, 100);
    //     return () => clearTimeout(timeoutId);
    // });


    return (
        <div id="rightEditor" className={showPreview ? `right right__fullscreen` : `right`} onClick={(e) => { 
            closeOverLay(e);
        }}>
            {showPreview ? <div className="close-wrap" onClick={() => { setShowPreview(!showPreview), removeBodyScroll(false) }}>
                <i>Close</i>
            </div> : ''}
            <div id="resume-download">
                <div className="paper preview-resume" id="preview-resume">
                    <div id="resume-page" className="page">
                        {<Resumes data={props.resume} scale={scale} />}
                    </div>
                </div>
            </div>
            {(!(window.location.pathname).includes('allinone') && window.location.pathname != REARRANGE_LINK)
            && <div className="bottom-btn-control">
                    {/* <div className="button button-1">
                        <div className="change-templ-action">
                            <span onClick={() => {
                                ga4Track('app_bottom_nav_templates', 'RT App', 'Bottom Nav: Templates');
                                localStorage.setItem('referrer', window.location.pathname);
                                history.push({
                                    pathname: FINAL_RESUME,
                                    state: {
                                        openPanel: true
                                    }
                                })
                            }}><i className="icon-grid"></i>Templates</span>
                        </div>
                    </div> */}
                    {/* <div className="button button-1 ai-change-btn">
                        <div className="change-templ-action round-btn round-btn-border"
                            onClick={() => {
                                ga4Track(
                                "app_te_templates_open",
                                "RB App",
                                "Traditional Editor: Open Template Selector"
                                );
                                 props.setShowTemplates(true);
                                 props.setShowAIAssistant(false);
                            }}>
                                
                            <i className="new-icon-grid"><IconGrid /></i>
                                <span>Templates</span>
                                
                            </div>
                        </div> */}
                    <div className="button button-1">&nbsp;</div>
                    <div className="btn-group-preview">
                        <button
                            type="button"
                            className="round-btn round-btn-border"
                            onClick={(e) => {
                                setShowPreview(!showPreview);
                                removeBodyScroll(true);
                                gaTrack('RT App', `Editor`, 'Preview');
                                ga4Track('app_editor_preview', 'RT App', 'Preview');
                                ga4Track('app_bottom_nav_preview', 'RT App', 'Bottom Nav: Preview');
                            }}>
                            <i className="new-icon-eye"><PreviewIcon /></i>
                            Preview
                        </button>
                    </div>
                </div>
            }
        </div>
    );

};

export default RightSection;
